import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import * as _ from 'underscore';

import { SearchFieldProps as SearchFieldWidgetProps, SearchFieldWidget } from '@tableau/widgets';

import { Messages } from '../../../codegen/Localize';
import { ContentFiltersKeys } from '../../../ts/models/ContentFilters';

export interface SearchFieldOwnProps {
  readonly searchTerm: string;
}

export type SearchFieldProps = SearchFieldOwnProps & RouteComponentProps;

export interface SearchFieldComponentState {
  readonly searchTerm: string;
  readonly searchTermUpdatePending: boolean;
}

export class SearchFieldComponent extends React.Component<SearchFieldProps, SearchFieldComponentState> {
  public static readonly InputDebounceMilliseconds = 250;

  public constructor(props: SearchFieldProps) {
    super(props);
    this.state = {searchTerm: props.searchTerm, searchTermUpdatePending: false};
  }

  static getDerivedStateFromProps(nextProps: SearchFieldProps, prevState: SearchFieldComponentState): Partial<SearchFieldComponentState>{
    // If we don't have any debounce pending (user hasn't typed into field lately) then take the props search term.
    if (!prevState.searchTermUpdatePending) {
      return {searchTerm: nextProps.searchTerm};
    }
    return {};
  }

  public shouldComponentUpdate(_nextProps: SearchFieldProps, nextState: SearchFieldComponentState): boolean {
    return this.state.searchTerm !== nextState.searchTerm;
  }

  public render() {
    const searchFieldProps: SearchFieldWidgetProps = {
      containerStyle: {width: '100%'},
      inputStyle: {},
      handleCancelSearch: this.handleCancelSearch,
      handleEscape: this.handleCancelSearch,
      handleChange: this.handleSearchChange,
      placeholder: Messages.searchboxPlaceholder(),
      placeholderStyle: {},
      testId: 'search-field',
      text: this.state.searchTerm,
    };

    return <SearchFieldWidget {...searchFieldProps} />;
  }

  private handleSearchChange = (text: string) => {
    this.setState({searchTerm: text, searchTermUpdatePending: true});
    this.debounceupdateSearchTerm(text);
  }

  private handleCancelSearch = () => {
    this.setState({searchTerm: ''});
    this.updateSearchTerm('');
  }

  private debounceupdateSearchTerm = _.debounce(this.updateSearchTerm, SearchFieldComponent.InputDebounceMilliseconds);
  private updateSearchTerm(text: string) {
    const query = new URLSearchParams(this.props.location.search);
    if (text) {
      query.set(ContentFiltersKeys.search, text);
    } else {
      query.delete(ContentFiltersKeys.search);
    }

    this.props.history.push({
      ...this.props.location,
      search: query.toString()
    });

    setTimeout(() => {
      // Only reset update pending if the text we've just updated url with
      // matches the text in the search input.
      // This prevents incorrect searchTerm updates between the time of the push to history and typing
      if (this.state.searchTerm === text) {
        this.setState({searchTermUpdatePending: false});
      }
    });
  }
}

export const SearchField: React.ComponentType<SearchFieldOwnProps> = withRouter(SearchFieldComponent);
